import React from 'react';
import { Link } from 'react-router-dom';

const Pipe = () => {
    return(
        <div className="PipeContainer">
            {/*
                <h1 className="PipeContainer__firstName">Martin</h1>
                <h1 className="PipeContainer__lastName">Ortega</h1>
            */}
            <h2 className="PipeContainer__pipe">Think. Design. Code.</h2>
            <h5 className="PipeContainer__pipeJoke">...Or whatever generic quote comes to mind.</h5>
        </div>
    )
}

const Description = () => {
    return(
        <div className="Description">
            <h3 className="Description__title">About</h3>
            <p className="Description__casaca">
                My name is Martin Ortega, a well-rounded web developer who has a good grip of front-end techniques, and I am here to help make your ideas into something awesome.
            </p>
            <Link className="Description__button" to="/about">Learn more...</Link>
        </div>
    )
} 

const AboutSummary = () => {
    return(
        <div className="AboutSummary">
            <Pipe></Pipe>
            <Description></Description>
        </div>
    )   
}

export default AboutSummary;